import * as api from "@/api/williams/project";
import { Project } from "@/api/project";
import { queryKeys } from "../../queryKeys";
import { useDebounce } from "@/hooks";
import { useQuery } from "react-query";

export function useSimilarProjects(project: Project) {
  const debounced = useDebounce(project, 500);
  const enabled = Boolean(debounced.name || debounced.number || debounced.description);

  return useQuery({
    enabled,
    keepPreviousData: enabled,
    queryKey: queryKeys.project.similar(debounced),
    queryFn: () => api.findSimilarProjects(debounced),
  });
}
